// NPM
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getTagsForRecommendation } from 'selectors';

import RecommendationProgramInfo from './RecommendationProgramInfo';
import RecommendationMatch from './RecommendationMatch';
import RecommendationActions from './RecommendationActions';
import RecommendationLocation from './RecommendationLocation';
import RecommendationTagList from './RecommendationTagList';

class Recommendation extends PureComponent {
  getBoundingBox = () => {
    return this.domNode.getBoundingClientRect();
  };

  setRef = node => {
    this.domNode = node;
  };

  render() {
    const {
      recommendation,
      tags,
      showFavoriteButton,
      showHideButton,
    } = this.props;

    return (
      <div
        className={`Recommendation ${
          recommendation.sponsored ? 'sponsored' : ''
        }`}
        ref={this.setRef}
      >
        <RecommendationProgramInfo recommendation={recommendation} />
        <RecommendationMatch match={recommendation.matchPercentage}>
          <RecommendationActions
            showFavoriteButton={showFavoriteButton}
            showHideButton={showHideButton}
            recommendation={recommendation}
          />
        </RecommendationMatch>

        <RecommendationLocation recommendation={recommendation} />
        <RecommendationTagList tags={tags} />
      </div>
    );
  }
}

Recommendation.propTypes = {
  recommendation: PropTypes.object.isRequired,
};

function mapStateToProps(state, props) {
  return {
    tags: getTagsForRecommendation(state, props),
  };
}

export default connect(mapStateToProps, null, null, { withRef: true })(
  Recommendation
);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/Recommendations/Recommendation.js